var pollTemplate = require("@/modules/components/poll.handlebars");
var pollResultTemplate = require("@/modules/components/poll-result.handlebars");
var pollMinimizedTemplate = require("@/modules/components/poll-minimized.handlebars");
import CheckIcon from "@/assets/media/icons/check.svg";
import HideIcon from "@/assets/media/icons/down-double-arrow.svg";
import ShowIcon from "@/assets/media/icons/up-double-arrow.svg";
import ChevronUpIcon from "@/assets/media/icons/chevron-up.svg";

import { appendCommonStyling } from "~/helpers";
class LoraPoll {
	constructor(
		parentElement,
		data,
		wrapLayout = ".lora-short__overlay__mid-left"
	) {
		this._parentElement = parentElement;
		this._data = data;
		this._wrapLayout = wrapLayout;
		this.checkIcon = CheckIcon;
		this.hideIcon = HideIcon;
		this.showIcon = ShowIcon;
		this.minimizeIcon = ChevronUpIcon;

		this._submittedCallback = null;
		this._pollingSelected = 0;
		this._pollingOptions = [];

        this.renderPollMinimizedLayout();
	}

	set clickedCallback(value) {
		this._submittedCallback = value;
	}

	get clickedCallback() {
		return this._submittedCallback;
	}

    async renderPollMinimizedLayout() {
        const wrapLayout = this._parentElement.querySelector(this._wrapLayout);
        const template = document.createElement("template");
        var context = {
            bgColor: this._data.bgColor,
			textColor: this._data.textColor,
        };
        template.innerHTML = `${pollMinimizedTemplate(context)}`;
        wrapLayout.innerHTML = '';
        await wrapLayout.appendChild(template.content.cloneNode(true));

        this._parentElement.querySelector(".lora-poll__btn-minimized").addEventListener("click", (event) => {
            event.stopPropagation();
            this.renderPollLayout();
        });
    }

	async renderPollLayout() {
		const wrapLayout = this._parentElement.querySelector(this._wrapLayout);
		const template = document.createElement("template");
		var context = {
			bgColor: this._data.bgColor,
			textColor: this._data.textColor,
			title: this._data.title,
			options: this._data.options,
			result: this._data.results,
			hideIcon: this.hideIcon,
			showIcon: this.showIcon,
			minimizeIcon: this.minimizeIcon,
		};

		template.innerHTML = `${pollTemplate(context)}`;
        wrapLayout.innerHTML = '';
		await wrapLayout.appendChild(template.content.cloneNode(true));
		appendCommonStyling(wrapLayout);
		if (this._data.result.answered) {
			// Result
			this.renderResultPoll();
		} else {
			this.pollEvents();
		}
        this._parentElement
			.querySelector(".lora-poll__action--minimized")?.addEventListener("click", (event) => {
				event.stopPropagation();
                this.renderPollMinimizedLayout();
			});
	}

	updatePollData(data) {
		this._data = data;
	}

	renderResultPoll() {
		const resultContext = this.formatResultData();
		let contentPoll = this._parentElement.querySelector(".lora-poll__content");
		contentPoll.innerHTML = `${pollResultTemplate(resultContext)}`;
		appendCommonStyling(contentPoll);
		this._parentElement
			.querySelector(".lora-poll--submit")
			.classList.add("lora--d-none");
		this._parentElement
			.querySelector(".lora-poll--submitted")
			.classList.add("lora--d-none");
		this._parentElement
			.querySelector(".lora-poll--show")
			.classList.remove("lora--d-none");
		contentPoll.classList.add("lora--d-none");
		this.pollResultEvents();
	}

	formatResultData() {
		const totalVoted = this._data.result.options.reduce((total, option) => {
			return (total += option.count);
		}, 0);
		var totalOptions = this._data.result.options.length;
		var totalPercent = 0;
		var nonOptionsSelected = this._data.result.options.every(
			(option) => option.count === 0
		);

		var answerOptions = this._data.result.options.map((option, index) => {
			let percent = parseFloat((option.count / totalVoted) * 100);
			if (isNaN(percent)) percent = 0;
			if (index === totalOptions - 1 && !nonOptionsSelected) {
				// last item
				option.percent = `${parseFloat((100 - totalPercent).toFixed(2))}%`;
			} else {
				option.percent = `${parseFloat(percent.toFixed(2))}%`;
			}
			if (option.optionId === this._data.result.optionId) {
				option.selected = true;
			}
			let questionOption = this._data.options.filter((question) => {
				return question.id === option.optionId;
			});
			option.title = questionOption.length ? questionOption[0].title : "";
			totalPercent += percent;
			return option;
		});
		return {
			options: answerOptions,
			successIcon: this.checkIcon,
		};
	}

	pollEvents() {
		// Click poll action
		this._pollingOptions =
			this._parentElement.querySelectorAll(".lora-poll__option");
		this._pollingOptions.forEach((pollingOption) => {
			pollingOption.addEventListener("click", (event) => {
				event.stopPropagation();
				if (this._data.result.answered) {
					return;
				}
				this._pollingSelected = parseInt(
					pollingOption.getAttribute("data-option-id")
				);
				this._parentElement.host.setAttribute(
					"polling-selected",
					this._pollingSelected
				);
				this.updatePollingOptionClass();
				this._pollOptionClickCallback();
			});
		});

		// Submit poll
		this.submitPollBtn =
			this._parentElement.querySelector(".lora-poll--submit");
		this.submitPollBtn.addEventListener("click", (event) => {
			event.stopPropagation();
			if (
				typeof this._submittedCallback === "function" &&
				this._pollingSelected
			) {
				this._submittedCallback(this._pollingSelected);
				this._parentElement
					.querySelector(".lora-poll--submitted")
					.classList.remove("lora--d-none");
				this._parentElement
					.querySelector(".lora-poll--submit")
					.classList.add("lora--d-none");
			}
		});

		
	}

	pollResultEvents() {
		let contentPoll = this._parentElement.querySelector(".lora-poll__content");
		let showPollBtn = this._parentElement.querySelector(".lora-poll--show");
		let hidePollBtn = this._parentElement.querySelector(".lora-poll--hide");

		showPollBtn.addEventListener("click", (event) => {
			event.stopPropagation();
			contentPoll.classList.remove("lora--d-none");
			showPollBtn.classList.add("lora--d-none");
			hidePollBtn.classList.remove("lora--d-none");
		});

		hidePollBtn.addEventListener("click", (event) => {
			event.stopPropagation();
			contentPoll.classList.add("lora--d-none");
			hidePollBtn.classList.add("lora--d-none");
			showPollBtn.classList.remove("lora--d-none");
		});
	}

	updatePollingOptionClass() {
		this._pollingOptions.forEach((pollingOption) => {
			let optionId = parseInt(pollingOption.getAttribute("data-option-id"));
			if (this._pollingSelected === optionId) {
				pollingOption.classList.add("selecting");
			} else {
				pollingOption.classList.remove("selecting");
			}
		});
		if (this._pollingSelected) {
			this.submitPollBtn.classList.remove("lora--disable");
		}
	}
}

export default LoraPoll;
